import {
  enableProdMode,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }]
  })
  .catch((err) => console.error(err));
